const colours = {
  roost_pink: "#EC2383",
  button_filling: "#FFFFFF",
  roost_blue: "#96D8E7",
  white: "#FFFFFF",
};

export default colours;
